module.exports = __webpack_public_path__ + "static/fonts/SCDream5.d2462cd.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SCDream/SCDream5.woff
// module id = X+M9
// module chunks = 1